import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Modal from 'component/utils/Modal'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'

class FeatureCheckModal extends Component {
  static propTypes = {
    translate: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    interfaces: PropTypes.object,
    user: PropTypes.object,
  }

  constructor(props) {
    super(props)

    this.state = {
      size: 'sm',
    }
  }

  renderContent = () => {
    const { translate, interfaces } = this.props
    return (
      <section>
        <Row>
          <Col xs={12} className='margin-bottom-double'>
            <legend className='margin-top no-margin-bottom'>
              {translate('feature-check.api')}
            </legend>
            <span className='info-label'>{interfaces.dsInterface}</span>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className='margin-bottom-double'>
            <legend className='margin-top no-margin-bottom'>
              {translate('feature-check.status')}
            </legend>
            <span className='info-label'>
              {interfaces.tpStatus ? interfaces.tpStatus : '-'}
            </span>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={12} className='margin-bottom-double'>
            <legend className='margin-top no-margin-bottom'>
              {translate('feature-check.return')}
            </legend>
            <span className='info-label'>{interfaces.dsReturn}</span>
          </Col>
        </Row>
      </section>
    )
  }

  render() {
    const { closeModal } = this.props
    const { size } = this.state

    return (
      <Modal closeModal={closeModal} size={size}>
        {this.renderContent()}
      </Modal>
    )
  }
}

export default FeatureCheckModal
